import React, { useState, useRef } from 'react';
import { sendEmail } from "../services/emailService";
import { useTranslation } from 'react-i18next';

const ContactForm = () => {
  const form = useRef();
  const { t } = useTranslation();

  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    const name = formData.get("name")?.trim();
    const phone = formData.get("phone")?.trim();
    const email = formData.get("email")?.trim();
    const message = formData.get("message")?.trim();

    if (!name || !email || !message) {
      setStatus("error");
      return;
    }

    setStatus("sending");

    const emailText = `
Nova poruka s zizi stranice:

Ime: ${name}
Email: ${email}
Telefon: ${phone || "Nije upisano"}
Poruka: ${message}
    `;

    try {
      await sendEmail(emailText);
      setStatus("success");
      form.current.reset();
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-content">
        <h2 className="contact-headline">{t('contactForm.headline')}</h2>
        <p className="contact-subheadline">
          {t('contactForm.subheadline')}
        </p>
        <form ref={form} className="contact-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group form-group-full">
              <label htmlFor="name">{t('contactForm.nameLabel')}</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className="form-group">
              <label htmlFor="phone">{t('contactForm.phoneLabel')}</label>
              <input type="tel" id="phone" name="phone" />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t('contactForm.emailLabel')}</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-group form-group-full">
              <label htmlFor="message">{t('contactForm.messageLabel')}</label>
              <textarea id="message" name="message" rows="4" required></textarea>
            </div>
          </div>
          <button type="submit" className="contact-submit-button" disabled={status === 'sending'}>
            {status === 'sending' ? t('contactForm.sending') : t('contactForm.sendMessage')}
          </button>
          {status === 'success' && (
            <p style={{ color: 'lightgreen', marginTop: '1rem' }}>{t('contactForm.successMessage')}</p>
          )}
          {status === 'error' && (
            <p style={{ color: 'red', marginTop: '1rem' }}>{t('contactForm.errorMessage')}</p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
